module.exports = __webpack_public_path__ + "static/img/multi-channel.6c812e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-live/multi-channel.png
// module id = uX3H
// module chunks = 12